export default __webpack_public_path__ + "static/media/truebg.badfb952.svg";